import * as React from 'react';
import { Styled } from '../styled';

export const Input = (props) => {
  const {
    width,
    text,
    input,
    type,
    placeholder,
    autoFocus,
    autoComplete,
    maxLength,
    icon,
    textTop,
    textLeft,
    min,
    max,
    isInvalid = false,
    height = '60px',
    paddingLeft = 20,
    fontSize = '16px',
  } = props;

  const inputProps = {
    ...(input || {}),
    type,
    placeholder,
    autoFocus,
    autoComplete,
    maxLength,
    min,
    max,
  };
  const { disabled, onChange } = input;
  const value = input.value || '';
  const inputLabel = text && (
    <Styled.InputText
      icon={icon}
      value={value}
      textTop={textTop}
      textLeft={textLeft}
    >
      {text}
    </Styled.InputText>
  );

  return (
    <Styled.InputContainer
      disabled={disabled}
      width={width}
      error={isInvalid}
      value={value}
      height={height}
    >
      <Styled.InputStyle
        icon={icon}
        {...inputProps}
        onChange={onChange}
        value={value}
        text={text}
        paddingLeft={paddingLeft}
        fontSize={fontSize}
      />
      {inputLabel}
      {icon && <div>{icon}</div>}
    </Styled.InputContainer>
  );
};
